// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2Kd2Q","imageUploader":"EGiftCard_imageUploader__2man6"};